
<template>
  <el-drawer size='1062px' :show-close="false" @opened="doRobotHide(true)" @closed="doRobotHide(false)" :visible.sync="drawer" :destroy-on-close="true">
    <div class="drawerWrap clearfix">
      <companyInfo :companyStatus="companyStatus"></companyInfo>
      <div class="number_box">
        <div class="fixation">
          <div class='fiexWrap'>
            <div class="box_top">
              <h5>联系方式</h5>
              <el-popover placement="top-start" popper-class="box_top_popClass" width="200" trigger="hover" content="所有信息均来自互联网公开数据，如您认为有侵犯到您的个人信息或隐私，请联系客服进行处理。">
                <span slot="reference"> <i class="el-icon-question"></i> </span>
              </el-popover>
            </div>
            <div class="box_tabs">
              <span @click="selectTabHead(index)" :class="{'current': showIndex === index}" v-for="(item,index) in tabList" :key="index">{{item.title}}({{ companyStatusLength[index] }})</span>
            </div>
            <div class="box_content_bot" v-if="nowShowPhoneList.length">
              <el-checkbox :disabled="!allowGet" v-model="checkedAll">全选</el-checkbox>
              <el-button :disabled="!allowGet" size="mini" class="fr" @click="getAll">转线索</el-button>
            </div>
          </div>
        </div>
        <div class="box_content" ref="box_content" v-loading="loading">
          <el-scrollbar style="height:100%;" ref="scrollbar">
            <div v-if="!contactWayList.length" class="emptyBox">
              <div>
                <div>
                  <img :src="emptyBox" alt="" srcset="">
                </div>
                <p>暂未查找到</p>
              </div>
            </div>
            <div class="contact-way-card" v-for="(item,index) in contactWayList" :key="index">
              <p>手机：<span>{{ item }}</span></p>
              <p>姓名：<span>{{ companyStatus.nickName }}</span></p>
              <p>来源：<span>{{ companyStatus.source === 'douyin' ? 'DY' : 'KS' }}</span></p>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>

  </el-drawer>
</template>

<script>
import smallDrawer from '@/components/smallDrawer'
import quan from '@/assets/quan.svg'
import emptyBox from '@/assets/emptyBox.svg'
import { feedback, feedbackDetail, contactSubmit } from '@/views/clue/api/newClueApi'
import { mapState } from 'vuex'
import companyInfo from './companyInfo'

const getPwdPhoneNumFunc = (e, i) => {
  if (i > 2 && i < 7) { return '*' }
  return e
}
export default {
  name: 'viewNumber',
  components: {
    smallDrawer,
    companyInfo
  },
  props: {
    // allowGet: {
    //   type: Boolean,
    //   default: true
    // },
    baseData: {
      type: Array,
      default: () => []
    },
    waiting: {
      type: Boolean,
      default: false
    },
    companyStatus: {
      type: Object,
      default: () => {}
    },
    type: {
      type: Number
    }
  },
  data () {
    return {
      quan,
      emptyBox,
      drawer: false,
      direction: 'rtl',
      tabList: [
        { title: '全部', list: [], total: 0 },
        { title: '手机', list: [], total: 0 },
        { title: '固话', list: [], total: 0 },
        { title: '邮箱', list: [], total: 0 }
      ],
      tabListCopy: [
        { title: '全部', list: 0 },
        { title: '手机', list: 0 },
        { title: '固话', list: 0 },
        { title: '邮箱', list: 0 }
      ],
      nowShowPhoneList: [],
      showIndex: 0,

      // 反馈
      numberFeedBack: ['正常号码', '空号', '停机', '不在服务区', '拒接', '错号', '关机'],
      checkList: [],
      feedBackWait: false,
      // 抽屉浮动
      position: false,
      contactWayList: [],
      loading: true
      // contactWayListLength: { 0: 0, 1: 0, 2: 0, 3: 0 }
    }
  },

  computed: {
    ...mapState({
      allowGet: state => state.user.hasCrmEquity
    }),
    phoneNum () {
      return item => {
        if (process.env.NODE_ENV == 'erp-prod' && item.content && item.isTurnClue) {
          const content = JSON.parse(JSON.stringify(item.content))
          return content.split('').map(getPwdPhoneNumFunc).join('')
        } else {
          return item.content
        }
      }
    },
    checkedAll: {
      get () {
        let isAll = true
        this.nowShowPhoneList.forEach(element => {
          if (!element.active) isAll = false
        })
        if (this.nowShowPhoneList.length === 0) isAll = false
        return isAll
      },
      set (val) {
        if (val) {
          this.nowShowPhoneList.forEach(element => {
            this.$set(element, 'active', true)
          })
        } else {
          this.nowShowPhoneList.forEach(element => {
            this.$set(element, 'active', false)
          })
        }
        return val
      }
    },
    companyName () {
      return (this.baseData[0] || {}).companyName || this.companyStatus.companyName
    },
    companyStatusLength () {
      const lenObj = { 0: 0, 1: 0, 2: 0, 3: 0 }
      lenObj[1] = this.companyStatus.phoneList ? this.companyStatus.phoneList.length : 0
      lenObj[2] = this.companyStatus.landlinePhoneList ? this.companyStatus.landlinePhoneList.length : 0
      lenObj[3] = this.companyStatus.emailList ? this.companyStatus.emailList.length : 0
      lenObj[0] = lenObj[1] + lenObj[2] + lenObj[3]
      return lenObj
    }
    // allContactWayList () {
    //   return { emailList: this.companyStatus.emailList, landlinePhoneList: this.companyStatus.landlinePhoneList, phoneList: this.companyStatus.phoneList }
    // }
  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 3000)
  },
  filters: {
    filterType (val) {
      let str
      switch (val) {
        case 1:
          str = '手机'
          break
        case 2:
          str = '固话'
          break
        case 3:
          str = '邮箱'
          break
      }
      return str
    }
  },
  watch: {
    drawer (val) {
      if (!val) {
        this.clearHistory()
        this.$store.commit('clearLastDrawer')
      }
    },
    // 联系方式次数查询之后设置
    'companyStatus.contactCount': {
      // immediate: true,
      handler (val) {
        if (val) {
          this.onlyLookTab()
        }
      }
    }
  },
  methods: {
    doRobotHide (flag) {
      this.selectTabHead(0)
      this.$store.commit('SET_ROBOT_HIDE', flag)
    },
    getStyle (status) {
      if (status == 1 || status == 5) {
        return 'tagsOther'
      } else {
        return 'tagsUnknown'
      }
    },
    getText (status) {
      if (status == 1) {
        return '号码检测结果：正常'
      } else if (status == 2) {
        return '号码检测结果：疑似空号/停机/不存在'
      } else {
        return '号码检测结果 ：未检测/沉默号'
      }
    },
    async contactSubmit (list) {
      const arr = list.filter(e => e.isTurnClue === 0 || JSON.stringify(e.isTurnClue) === 'null')
      if (!arr.length) {
        this.$message.warning('已经领取过了')
        return
      }
      const params = {
        contactInfoList: [{
          companyName: arr[0].companyName,
          hid:arr[0].hid,
          contacts: arr.map(e => {
            return {
              contactInfo: e.contactInfo,
              contactName: e.contactName,
              type: e.type
            }
          })
        }]
      }
      const { code } = await contactSubmit(params)
      if (code === 200) {
        this.$message.success('领取成功')
        this.$emit('refreshList')
      }
    },
    onlyLookTab () {
      const { contactCount, countMap } = this.companyStatus.contactCount
      this.tabList[0].total = contactCount || 0
      // 1:手机，2:固话，3:邮箱，4:微信，5:QQ，6:传真
      this.tabList[1].total = (countMap && countMap[1]) || 0
      this.tabList[2].total = (countMap && countMap[2]) || 0
      this.tabList[3].total = (countMap && countMap[3]) || 0
    },
    init () {
      this.clearHistory()
      this.tabList[0].list = this.baseData.filter(e => e.type)
      this.tabList[1].list = this.baseData.filter(e => e.type === 1)
      this.tabList[2].list = this.baseData.filter(e => e.type === 2)
      this.tabList[3].list = this.baseData.filter(e => e.type === 3)
      this.nowShowPhoneList = this.tabList[0].list
    },
    clearHistory () {
      this.showIndex = 0
      this.nowShowPhoneList = []
    },
    drawerTaggle () {
      this.drawer = !this.drawer
    },
    getAll () {
      const arr = this.nowShowPhoneList.filter(e => e.active)
      if (arr.length) {
        // this.$message.warning('功能暂未开放')
        this.contactSubmit(arr)
      } else {
        this.$message.warning('至少选择一个线索')
      }
    },
    // clickEnterprise() {
    //   const routeUrl = this.$router.resolve({
    //     path: '/clue/enterprise',
    //     query: {
    //       name: this.companyName,
    //       similarValue: (this.$parent.baseData || this.$parent).similarValue || '',
    //       similarity: (this.$parent.baseData || this.$parent).similarity || ''
    //     }
    //   })
    //   window.open(routeUrl.href, '_blank')
    // },
    selectThis (item, e) {
      if (item.isDel == 1) return
      if (!this.allowGet) return
      if (!e.target.className.includes('noActive')) {
        if (item.active) {
          item.active = !item.active
        } else {
          this.$set(item, 'active', true)
        }
      }
    },
    selectTabHead (index) {
      this.showIndex = index
      const mapObj = {
        0: [],
        1: this.companyStatus.phoneList || [],
        2: this.companyStatus.landlinePhoneList || [],
        3: this.companyStatus.emailList || []
      }
      // if (type === 'first') {
      //   mapObj[0] = mapObj[1].concat(mapObj[2]).concat(mapObj[3])
      //   this.contactWayList = mapObj[0]
      // }
      if (index === 0) {
        mapObj[0] = mapObj[1].concat(mapObj[2]).concat(mapObj[3])
        this.contactWayList = mapObj[0]
      } else {
        this.contactWayList = mapObj[index]
      }
      // this.contactWayListLength = { 0: mapObj[0].length, 1: mapObj[1].length, 2: mapObj[2].length, 3: mapObj[3].length }
      this.checkedAll = false
      // 重置滚动条
      // console.log(this.$refs.box_content)
      // console.log(
      const dom = document.getElementsByClassName('box_content')
      if (dom.length) {
        const dom1 = document.getElementsByClassName('box_content')[0].firstChild.firstChild
        dom1.scrollTop = 0
      }

      // 修改 ie11下 无法收回popover
      this.$nextTick(() => {
        this.nowShowPhoneList = this.tabList[index].list
      })
    },

    togglePop (item) {
      if (item.visible) {
        item.visible = !item.visible
      }
    },
    async getFeedbackDetail (item) {
      this.feedBackWait = true
      this.checkList = []
      const res = await feedbackDetail({ companyName: this.companyName, contactInfo: item.contactInfo })
      if (res.data) {
        this.checkList = res.data?.feedbackContent?.split(',') || []
      }
      this.feedBackWait = false
    },
    async sureFeedBack (item) {
      if (this.checkList.length) {
        await feedback({ companyName: this.companyName, contactInfo: item.contactInfo, feedback: this.checkList.join(',') })
        this.$message.success('反馈成功')
        this.togglePop(item)
      } else {
        this.$message.warning('至少选择一项')
      }
    }
  }
}
</script>
<style>
.popShow {
  padding: 10px;
  font-size: 12px;
  border: 1px solid #ddd;
}
</style>
<style lang="scss">
.box_top_popClass {
  font-size: 12px;
  padding: 12px 16px;
}
</style>
<style lang='scss' scoped>
/deep/ .el-drawer {
  // overflow-x: unset;
  // overflow-y: hidden;
  // overflow: hidden;
}
.popClass {
  font-size: 12px;
}
.closeBtn {
  float: left;
  width: 30px;
  height: 100%;
  background-color: #fff;
}
.drawerWrap {
  // overflow: hidden;
  background: rgb(241, 242, 244);

  .main {
    float: left;
    width: calc(100% - 340px);
    margin: 15px;
    margin-right: 0;
    height: 100vh;
  }
  .number_box {
    float: right;
    width: 300px;
    background: #fff;
    height: 100vh;
    margin: 15px;
    margin-left: 0;
    // overflow: auto;
    // position: absolute;
    // z-index: 25;
    .fixation {
      height: 90px;
      position: relative;
      .fiexWrap {
        width: 300px;
        background-color: #fff;
        position: fixed;
        box-shadow: 0 2px 5px 0px rgba(0, 0, 0, 0.1);
        z-index: 11;
        .box_top {
          padding: 0 10px;
          padding-right: 20px;
          line-height: 50px;
          border-bottom: 1px solid #f2f2f2;
          display: flex;
          // justify-content: space-between;
          > h5 {
            font-weight: 400;
            font-size: 14px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            cursor: pointer;
          }
          > span {
            font-size: 12px;
            padding: 1px 5px;
            // background-color: #ebf0fe;
            color: #4f7afd;
            display: block;
            height: 20px;
            line-height: 20px;
            border-radius: 4px;
            margin-top: 15px;
            // text-overflow: ellipsis;
            // overflow: hidden;
            // white-space: nowrap;
          }
        }
        .box_tabs {
          border-bottom: 1px solid #f2f2f2;
          text-align: center;
          padding-right: 10px;

          > span {
            width: calc(25%);
            display: inline-block;
            line-height: 40px;
            cursor: pointer;
            &:hover {
              color: #f59a23;
            }
          }
          .current {
            color: #f59a23;
          }
        }
        .box_content_bot {
          padding: 10px;
          line-height: 30px;
        }
      }
    }
    .box_content {
      padding: 10px;
      position: relative;
      height: calc(100% - 142px);
      .emptyBox {
        width: 100%;
        margin: 200px auto;
        text-align: center;
        img {
          width: 64px;
        }
        p {
          color: #aaa;
        }
      }
      .hiddenImg {
        position: absolute;
        top: 0;
        background-color: #fff;
        > img {
          width: 280px;
          height: 100vh;
        }
        .looknumber {
          position: absolute;
          top: 210px;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
        }
      }
      .box_content_list {
        padding-right: 10px;
      }

      .box_content_list li {
        border: 1px solid #ddd;
        padding: 10px 10px 10px 15px;
        margin-bottom: 15px;
        position: relative;
        // cursor: pointer;
        .isreceiver {
          position: absolute;
          right: 10px;
          top: 0;
          color: #fff;
          font-size: 12px;
          background: #dc8b22;
          padding: 0 5px;
          border-radius: 0 0 4px 4px;
        }
        p {
          font-size: 12px;

          &.setP {
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          > a {
            margin-right: 10px;
          }
          i {
            font-weight: 500;
            font-size: 12px;
            color: #333;
          }
          .tags {
            border-radius: 4px;
            background-color: skyblue;
            padding: 2px 5px;
            color: #fff;
            font-size: 12px;
          }
          .tagsOther {
            border-radius: 4px;
            background-color: #f59a23;
            padding: 2px 5px;
            color: #fff;
            font-size: 12px;
          }
          .tagsUnknown {
            border-radius: 4px;
            background-color: #ddd;
            padding: 2px 5px;
            color: #a09e9e;
            font-size: 12px;
          }
          .nohands {
            cursor: initial;
          }
          .fontSize {
            font-size: 12px;
          }
          .hover:hover {
            color: #dc8b22 !important;
          }
          .source {
            font-size: 12px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: inline-block;
            width: 100%;
            > img {
              vertical-align: initial;
              margin-right: 3px;
            }
          }
        }
        .checked {
          display: none;
        }
        .good {
          background-color: #f59a23;
          border-radius: 0 0 4px 4px;
          font-size: 12px;
          color: #fff;
          padding: 1px 5px;
          position: absolute;
          top: 0;
          right: 10px;

          > img {
            width: 10px;
            vertical-align: unset;
          }
        }
      }
      .box_content_list .active {
        border: 1px solid rgba(80, 122, 251, 1);
        .checked {
          display: block;
          position: absolute;
          top: 0px;
          left: 0px;
          width: 0;
          height: 0;
          border-top: 20px solid rgba(80, 122, 251, 1);
          border-right: 30px solid transparent;
          color: #fff;
          > i {
            position: absolute;
            top: -20px;
            left: 1px;
          }
        }
      }

      .box_content_list li.pointer:hover {
        border: 1px solid rgba(80, 122, 251, 1);
      }
    }
    .underline {
      text-decoration: underline;
      color: #f59a23 !important;
      font-size: 12px;
    }
  }
}

.sureFeedBack {
  background-color: royalblue;
  color: #fff;
  cursor: pointer;
  width: 46px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 3px;
  display: inline-block;
  /* margin-left: 20px; */
  position: relative;
  left: 50%;
  /* top: 0px; */
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  &:hover {
    background-color: #4169e1cf;
  }
}
/deep/ .el-drawer__header {
  margin: 0;
  padding: 0;
}
/deep/ .el-scrollbar__wrap {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

// /deep/ .el-drawer__body {
//   overflow-y: auto;
//   overflow-x: hidden;
// }

/*滚动条宽 长,滚动条整体部分，其中的属性有width,height,background,border等。*/

/deep/ .el-drawer__body::-webkit-scrollbar {
  width: 7px;
}

/*滚动条的滑轨背景颜色,可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

/deep/ .el-drawer__body::-webkit-scrollbar-track {
  background-color: transparent;

  // -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);

  border-radius: 5px;
}

/* 滑块颜色 */

/deep/ .el-drawer__body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);

  border-radius: 5px;
}

/*滚动条两端的按钮。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

/deep/ .el-drawer__body::-webkit-scrollbar-button {
  background-color: #eee;

  display: none;
}

/* 横向滚动条和纵向滚动条相交处尖角的颜色 */

/deep/ .el-drawer__body::-webkit-scrollbar-corner {
  background-color: black;
}

.contact-way-card {
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #f1f2f4;
  p {
    height: 40px;
    line-height: 40px;
  }
}
</style>
